// extracted by mini-css-extract-plugin
module.exports = {"outer":"workshopInfo_outer__a8h6K","resets":"workshopInfo_resets__2xIt2","butt":"workshopInfo_butt__2N8b6"};